import {
  BaSeAccordion,
  BaSeLoading,
  BaSeParagraph,
  BaSeSmall2,
} from '@base/react';
import React from 'react';
import { Container } from './summary-style';

function Summary({ summary, summaryLength, laoding }) {
  return (
    <BaSeAccordion
      backgroundContentColor="#fff"
      backgroundTitleColor="#ffffff"
      borderTitleColor="#f5f7fa"
      multipleOpen
      startOpen={[0]}
      options={[
        {
          title: 'Resumo da resposta',
          content: laoding ? (
            <BaSeLoading
              description=""
              lightMode="default"
              shadowLevel={0}
              spinnerColor=""
              spinnerSize={24}
              text="Carregando…"
              textColor=""
            />
          ) : (
            <Container>
              <BaSeParagraph>{summary}</BaSeParagraph>
              <BaSeSmall2 isThin>{summaryLength} palavras digitadas</BaSeSmall2>
            </Container>
          ),
        },
      ]}
      radius={8}
      titleColor="#617385"
    />
  );
}

export default Summary;
